<template>
    <div>
        <div class="image-section">
            <img src="@/assets/zheyb/zyb1.jpg"  class="product-image">
            <img src="@/assets/zheyb/zyb2.jpg"  class="product-image">
            <img src="@/assets/zheyb/zyb4.jpg"  class="product-image">
            <img src="@/assets/zheyb/zyb5.jpg"  class="product-image">
            <img src="@/assets/zheyb/zyb6.jpg"  class="product-image">
            <img src="@/assets/zheyb/zyb7.jpg"  class="product-image">
            <img src="@/assets/zheyb/zyb8.jpg"  class="product-image">
            <img src="@/assets/zheyb/zyb9.jpg"  class="product-image">
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.image-section{
    display: flex;
    flex-direction: column;
    margin-top: 60px;
    align-items: center
}
.product-image{
    width: 1000px;
    height: 1000px;
}
</style>
